import { render, staticRenderFns } from "./passConfirm.vue?vue&type=template&id=b9b895f0&"
import script from "./passConfirm.vue?vue&type=script&lang=js&"
export * from "./passConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports